module.exports = __webpack_public_path__ + "static/media/sample_passport.7d176241.jpg";